module.exports = __webpack_public_path__ + "img/footprints - gandalf.14906187.svg";